import { render } from "./eventCard.vue?vue&type=template&id=1a23050f&scoped=true"
import script from "./eventCard.vue?vue&type=script&lang=js"
export * from "./eventCard.vue?vue&type=script&lang=js"

import "./eventCard.vue?vue&type=style&index=0&id=1a23050f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a23050f"

export default script